import type { StringSchema } from 'yup';
import * as yup from 'yup';

import { CONVERSATION_TITLE_MAX_LENGTH } from '@nora-monorepo/shared';

/** Represents a translator like i18n */
type Translate = (key: string, params?: unknown) => string;

/**
 * Creates the yup schema for conversation names.
 */
export function createConversationNameSchema(t: Translate): StringSchema<string> {
  return yup
    .string()
    .trim()
    .required(t('operation.validation.conversationNameRequired'))
    .max(
      CONVERSATION_TITLE_MAX_LENGTH,
      t('operation.validation.conversationNameMaxLengthExceeded', [CONVERSATION_TITLE_MAX_LENGTH]),
    );
}
